import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-bootstrap/Modal';
import {Message} from '@aperza/ui';

export default class ClipNotificationModal extends React.Component {

  static propTypes = {
    open: PropTypes.bool,
    onClose: PropTypes.func,
  };

  onClose = () => {
    if (this.props.onClose) {
      this.props.onClose();
    }
  };

  render() {

    let messageId = this.props.serviceId == 3 ? "clip.email.notification.3" :
      this.props.serviceId == 5 ? "clip.email.notification.5" : "clip.email.notification.default"

    return (
      <Modal
        show={this.props.open}
        onHide={::this.onClose}
        id="ClipClipboardNotificationModal"
        dialogClassName={'ClipClipboardNotificationModal'}
        centered
      >
        <Modal.Body>
          <div>
            <span className="aw-icon aw-icon-white aw-icon-clip"></span><Message messageId={messageId} />
          </div>
        </Modal.Body>
      </Modal>
    )
  }

}
